import { OAuthName } from './types.js';

const OAuthNameText = {
    [OAuthName.OK]: 'OK',
    [OAuthName.MAIL]: 'Mail',
    [OAuthName.VK]: 'VK ID'
};

export { OAuthNameText };
